import { setUser } from '@features/auth/auth-actions'
import { api as modulesApi } from './auto-generated/modules'
import { api as authApi } from './auto-generated/auth'
import { api as revisionApi } from './auto-generated/revision'
import { current } from '@reduxjs/toolkit'

modulesApi.enhanceEndpoints({
  endpoints: {
    modulesSubmitModuleResult: {
      invalidatesTags: ['Modules'],
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        let patchResult
        switch (args.moduleResult.id) {
          case 'TeacherStudentQuestionnaire':
            patchResult = dispatch(
              authApi.util.updateQueryData('authWhoami', undefined, (draftUser) => {
                draftUser.status = args.moduleResult.data.status
                dispatch(setUser(current(draftUser)))
              }),
            )
            break
          case 'UserAddressModule':
            patchResult = dispatch(
              authApi.util.updateQueryData('authWhoami', undefined, (draftUser) => {
                draftUser.profile = args.moduleResult.data
                dispatch(setUser(current(draftUser)))
              }),
            )
            break
          case 'OnboardingTourModule':
            patchResult = dispatch(
              authApi.util.updateQueryData('authWhoami', {}, (draftUser) => {
                draftUser.completed_onboarding = true
                dispatch(setUser(current(draftUser)))
              }),
            )
            break
          case 'LanguageQuestionnaire':
            patchResult = dispatch(
              authApi.util.updateQueryData('authWhoami', undefined, (draftUser) => {
                draftUser.learning = args.moduleResult.data.learning
                draftUser.speaking = args.moduleResult.data.speaking
                dispatch(setUser(current(draftUser)))
              }),
            )
            break
          case 'TeacherBioModule':
            patchResult = dispatch(
              authApi.util.updateQueryData('authWhoami', undefined, (draftUser) => {
                draftUser.profile.bio = args.moduleResult.data?.bio
                draftUser.profile.experience = args.moduleResult.data?.experience
                draftUser.profile.tags = args.moduleResult.data?.tags
                draftUser.profile.teaching_style = args.moduleResult.data?.teaching_style
                dispatch(setUser(current(draftUser)))
              }),
            )
            break
          case 'VideoLinkQuestionnaire':
            patchResult = dispatch(
              authApi.util.updateQueryData('authWhoami', undefined, (draftUser) => {
                draftUser.profile.video_link = args.moduleResult.data?.video_link
                dispatch(setUser(current(draftUser)))
              }),
            )
            break
          case 'PreferredAccentModule':
            patchResult = dispatch(
              modulesApi.util.updateQueryData(
                'modulesGetUserModules',
                undefined,
                (draftModules) => {
                  draftModules.submitted.push('PreferredAccentModule')
                },
              ),
            )
            break
          case 'RecordingModule':
            patchResult = dispatch(
              revisionApi.util.updateQueryData(
                'revisionListRecordings',
                undefined,
                (draftRecordings) => {
                  draftRecordings.unshift({
                    audio_url: args.moduleResult.data.recording,
                    id: moduleResults.id,
                  })
                },
              ),
            )
          default:
            break
        }
        try {
          await queryFulfilled
        } catch {
          if (patchResult) {
            patchResult.undo()
          }
        }
      },
    },
    modulesGetUserModules: {
      providesTags: ['Modules'],
    },
  },
})

export { modulesApi }
